import moment from 'moment';

export type SortByValue = 'checkInDate' | 'checkOutDate';

export type ColumnKey =
  | 'reservationId'
  | 'area'
  | 'project'
  | 'unitId'
  | 'guestName'
  | 'phoneNumber'
  | 'checkIn'
  | 'checkOut'
  | 'nights'
  | 'status'
  | 'source';
// | 'guestType'
// | 'notes'
// | 'insurance'
// | 'cards'
// | 'cardsAmount'
// | 'cardsInsurance';

export const COLUMN_CONFIG: {
  key: ColumnKey;
  label: string;
  align?: 'text-left' | 'text-center';
}[] = [
  { key: 'reservationId', label: 'Reservation ID' },
  { key: 'area', label: 'Area' },
  { key: 'project', label: 'Project' },
  { key: 'unitId', label: 'Unit ID' },
  { key: 'guestName', label: 'Guest Name' },
  { key: 'phoneNumber', label: 'Phone Number' },
  { key: 'checkIn', label: 'Check in' },
  { key: 'checkOut', label: 'Check out' },
  { key: 'nights', label: '# of Nights', align: 'text-center' },
  { key: 'status', label: 'Reservation Status' },
  { key: 'source', label: 'Source' }
  // { key: 'guestType', label: 'Guest Type' },
  // { key: 'notes', label: 'Notes' },
  // { key: 'insurance', label: 'Insurance' },
  // { key: 'cards', label: 'Cards' },
  // { key: 'cardsAmount', label: 'Cards Amount' },
  // { key: 'cardsInsurance', label: 'Cards Insurance' }
];

export const COLUMNS_STORAGE_KEY = 'operations-table-visible-columns';
export const DEFAULT_VISIBLE_COLUMNS: ColumnKey[] = COLUMN_CONFIG.map((col) => col.key);

export const getStatusStyles = (status?: string) => {
  switch (status) {
    case 'checked_in':
    case 'checked_in_started':
      return 'bg-primary-500 text-primary-50 border-primary-200';
    case 'pending_check_in':
    case 'confirmation_pending':
      return 'bg-yellow-50 text-yellow-500 border-yellow-400';
    case 'canceled':
      return 'bg-red-100 text-red-800 border-red-100';
    case 'checked_out':
      return 'bg-gray-100 text-neutral-800 border-gray-200';
    case 'expired':
      return 'bg-scarlet text-white border-scarlet';
    case 'in_house':
      return 'bg-primary-50 text-primary-600 border-primary-100';
    default:
      return 'bg-blue-50 text-blue-600 border-blue-100';
  }
};

export function getRowTypeStyles(type?: string) {
  if (type === 'blockDate') return 'bg-gray-50 hover:bg-gray-100/60';
  return 'hover:bg-primary-50/40';
}

export function formatCellDate(ms?: number) {
  if (!ms) return '—';
  return moment(ms).format('ddd M/D/YYYY');
}

export function normalizeStatusLabel(status?: string) {
  if (!status) return '—';
  return status.replaceAll('_', ' ');
}

export const selectMenuPortalStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
};
